import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Labels from '../../components/translations/translation.json'
import { Button, Dialog, DialogContent, DialogContentText, DialogTitle, DialogActions } from '@mui/material';
//css file
import './emailWarningModal.css';
import {languageCodeMapper} from '../../components/space/translationCodeMapper';

function EmailWarningModal(props) {

    const [open] = useState(true);
    const [close] = useState(true);

    console.log("props langCode",props.langProp)
    // const propsLangCode = languageCodeMapper(props.langCode);

    const handleClose = () => {
      props.callback(false);
      window.open("about:page", "_self");
      window.close();
    }

  return (
    <>
      <Dialog aria-labelledby="customized-dialog-title" className='dialog-modal' open={open}>
        <DialogTitle className="dialogTitle-emailWarning" sx={{ m: 0, p: 2 }}>
        {Labels[props.langProp].WARNING}
          {close ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: '#000',
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
        <DialogContent dividers className="dialog-content">
          <DialogContentText className="dialog-content-text">
            <span className="textBody-emailWarningModal">{Labels[props.langProp].EMAIL_WARNING_MODAL}</span>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" className="button-ok-emailWarning" onClick={handleClose}>{Labels[props.langProp].OK}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

EmailWarningModal.propTypes = {
  langProp: PropTypes.string,
  callback: PropTypes.func,
};

export default EmailWarningModal;
